let $ = jQuery.noConflict();

(() => {

    // Block Name
    const blockName = 'greengzm-hero';

    // Variables
    let method = 'front';
    if (document.querySelector('body') == null || document.querySelector('body').classList.contains('wp-admin')) {
        method = 'wp-admin';
    }
    // -- end

    // Custom methods

    // -- end

    // Init blocks
    const initializeBlock = (block) => {
        if (block[0] !== undefined) block = block[0].querySelector(`.block-${blockName}`);
        if (block === false || block === null) return;

        $(document).ready(function () {
            function filter() {
                $('#gmz-filter-submit').submit(function (e) {
                    e.preventDefault();        // disable form submit
                });
                $('#gmz-filter-submit .gzm-filter__submit').click(function (e) {
                    e.preventDefault();
                    $('.c-park').removeClass('js-active');

                    // filter selections
                    let filterRegion = false;
                    let filterAreaMin = false;
                    let filterAreaMax = false;
                    let filterAttractions = [];

                    filterRegion = $(this).parents('form').find('select[name="filter-region"]').val();
                    filterAreaMin = $(this).parents('form').find('select[name="filter-area-min"]').val();
                    filterAreaMax = $(this).parents('form').find('select[name="filter-area-max"]').val();
                    filterAreaMax = filterAreaMax <= 0 ? Infinity : filterAreaMax;
                    $.each($(this).parents('form').find('input[name="filter-attraction[]"]:checked'), function (key, val) {
                        filterAttractions.push($(this).val());
                    });

                    //check for attributes
                    if (filterRegion == 'all') {
                        $('.block-green-gzm__listing').addClass('js-active');
                    } else if (filterRegion) {
                        $('[data-filter-region]').removeClass('js-active');
                        $('[data-filter-region="' + filterRegion + '"]').addClass('js-active');
                    }

                    if (filterAreaMin || filterAreaMax) {
                        elArea = $('.c-park[data-filter-area]');
                        elArea.removeClass('js-preactive-area');

                        $.each(elArea, function (_key, _val) {
                            if ($(this).data('filter-area') >= filterAreaMin && $(this).data('filter-area') <= filterAreaMax) {
                                $(this).addClass('js-preactive-area');
                            }
                        });
                    }

                    let elAttraction;
                    let dataAttraction;
                    if (filterAttractions.length > 0) {
                        elAttraction = $('.c-park[data-filter-attraction]');
                        elAttraction.removeClass('js-preactive-attraction');

                        $.each(elAttraction, function (_key, _val) {
                            dataAttraction = $(this).data('filter-attraction');
                            let arrayAttraction = [];
                            arrayAttraction = dataAttraction.split(' ');

                            let check = false;
                            $.each(arrayAttraction, function (index, value) {
                                if (filterAttractions.includes(value)) {
                                    check = true;
                                }
                            });

                            if (check == true) {
                                $(this).addClass('js-preactive-attraction');
                            }
                        });
                    }

                    // final result
                    $('.c-park').each(function () {
                        if ($(this).hasClass('js-preactive-area') && filterAttractions.length == 0) {
                            $(this).addClass('js-active');
                        }
                        if ($(this).hasClass('js-preactive-attraction') && filterAreaMin == 0 && filterAreaMax == Infinity) {
                            $(this).addClass('js-active');
                        }
                        if ($(this).hasClass('js-preactive-area') && $(this).hasClass('js-preactive-attraction')) {
                            $(this).addClass('js-active');
                        }
                    });
                    $('.c-park').removeClass('js-preactive-area, js-preactive-attraction');
                    $('.block-green-gzm__listing').each(function () {
                        let countElements = $(this).find('.c-park.js-active').length;
                        if (countElements < 1) {
                            $(this).removeClass('js-active');
                        }
                    });
                    if ($('.block-green-gzm__listing.js-active').length < 1) {
                        $('.block-green-gzm__listing.js-empty').addClass('js-active');
                    }
                });
            }

            filter();
        });
    };

    // Get all blocks
    const getBlocks = () => {
        let blocks = document.querySelectorAll(`.block-${blockName}`);
        if (blocks.length > 0) {
            blocks.forEach((block) => {
                initializeBlock(block);
            });
        }
    };

    // Frontend
    document.addEventListener("DOMContentLoaded", getBlocks);

    // Acf Init
    window.addEventListener('load', (event) => {
        if (window.acf) {
            getBlocks();

            // Add update block action for ACF
            window.acf.addAction(`render_block_preview/type=${blockName}`, initializeBlock);
        }
    });
})();
